/**
 * Las iniciales de las dos primeras palabras: «Camila Rojas Pérez» → «CR».
 *
 * En archivo propio y no en `Avatar.tsx`: un módulo de componente que exporta
 * también una función deja de recargarse con fast refresh.
 */
export function iniciales(nombre: string): string {
  const partes = (nombre || '').trim().split(/\s+/).filter(Boolean)
  return partes.slice(0, 2).map(p => p[0]!.toLocaleUpperCase('es')).join('') || '?'
}
